import { createReducer } from "typesafe-actions";

import { MultiPin } from "@mapmycustomers/shared/types/map";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import UpcomingActivitiesCardConfiguration from "@app/types/dashboard/cards/upcomingActivities/UpcomingActivitiesCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyUpcomingActivitiesDrillDownListViewSettings,
  fetchUpcomingActivitiesCardDrillDownData,
  hideUpcomingActivitiesDrillDown,
  showUpcomingActivitiesDrillDown,
  UpcomingActivitiesCardActions,
} from "./actions";

export interface UpcomingActivitiesCardState {
  bounds?: MultiPin["bounds"];
  configuration?: UpcomingActivitiesCardConfiguration; // also works as a "visible" trigger, visible if set
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const upcomingActivitiesInitialState: UpcomingActivitiesCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const upcomingActivitiesState = createReducer<
  UpcomingActivitiesCardState,
  UpcomingActivitiesCardActions
>(upcomingActivitiesInitialState)
  .handleAction(showUpcomingActivitiesDrillDown.request, (state, { payload }) => ({
    ...state,
    bounds: payload.bounds,
    configuration: payload.configuration,
  }))
  .handleAction(showUpcomingActivitiesDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideUpcomingActivitiesDrillDown, (state) => ({
    ...state,
    configuration: undefined,
  }))
  .handleAction(fetchUpcomingActivitiesCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchUpcomingActivitiesCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchUpcomingActivitiesCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyUpcomingActivitiesDrillDownListViewSettings, (state, { payload }) => {
    return {
      ...state,
      viewState: {
        ...state.viewState,
        columns: payload.columns ?? state.viewState.columns,
        filter: payload.filter ?? state.viewState.filter,
        range: payload.range ?? state.viewState.range,
        sort: payload.sort ?? state.viewState.sort,
      },
    };
  });

export default upcomingActivitiesState;
